export const baseUrl = process.env.GATSBY_COMMERCE_BASE_URL
export const NETLIFY_URL = "/.netlify/functions"
